import React from 'react';
import { useIntl } from 'react-intl-next';
import VerifiedIcon from '@atlaskit/icon/core/status-verified';
import { VerifiedIcon as LegacyVerifiedIcon } from '@atlaskit/legacy-custom-icons';
import Tooltip from '@atlaskit/tooltip';
import { messages } from './messages';
export var VerifiedTeamIcon = function VerifiedTeamIcon(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Verified Team' : _ref$label,
    showTooltip = _ref.showTooltip,
    customTooltipContent = _ref.customTooltipContent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var tooltipContent = showTooltip ? customTooltipContent || formatMessage(messages.verifiedIconDefaultTooltip) : undefined;
  return tooltipContent ? /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent
  }, /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    role: "button",
    "aria-hidden": "true",
    "data-testid": "verified-team-icon"
  }, ' ', /*#__PURE__*/React.createElement(VerifiedIcon, {
    color: "var(--ds-icon-accent-blue, #1D7AFC)",
    LEGACY_size: "medium",
    label: tooltipContent,
    spacing: "spacious",
    LEGACY_fallbackIcon: LegacyVerifiedIcon
  }))) : /*#__PURE__*/React.createElement(VerifiedIcon, {
    color: "var(--ds-icon-accent-blue, #1D7AFC)",
    LEGACY_size: "medium",
    spacing: "spacious",
    label: label,
    LEGACY_fallbackIcon: LegacyVerifiedIcon
  });
};